import type { JSX } from "react";

type LoaderProps = {
  size?: "sm" | "md" | "lg";
  className?: string;
};

/**
 * Small reusable loader that uses Bootstrap spinner styles.
 */
const Loader = ({ size = "md", className = "" }: LoaderProps): JSX.Element => {
  const sizeStyle =
    size === "sm"
      ? { width: "1rem", height: "1rem" }
      : size === "lg"
      ? { width: "1.5rem", height: "1.5rem" }
      : { width: "1.1rem", height: "1.1rem" };

  return (
    <span
      className={`spinner-border spinner-border-sm text-light ${className}`}
      role="status"
      aria-hidden="true"
      style={{ verticalAlign: "text-bottom", ...sizeStyle }}
    />
  );
};

export default Loader;
